(function() {
  'use strict';

  // Slider functionality - same as conditions section
  function initTestimonialSlider() {
    if (typeof $ === "undefined" || typeof $.fn.slick === "undefined") {
      setTimeout(initTestimonialSlider, 100);
      return;
    }

    const slider = $("#testimonial-mobile-slider");
    if (!slider.length) return;

    function isMobile() {
      return window.innerWidth <= 768;
    }

    function enableSlider() {
      if (!slider.hasClass("slick-initialized")) {
        const prevButton = $(".testimonial-section__slider-nav--prev");
        const nextButton = $(".testimonial-section__slider-nav--next");

        slider.slick({
          slidesToShow: 1.20,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          dots: false,
          speed: 400,
          swipe: true,
          touchMove: true,
          swipeToSlide: false,
          draggable: true,
          touchThreshold: 5,
          adaptiveHeight: true,
          useCSS: true,
          useTransform: true,
          waitForAnimate: true,
          centerMode: true,
          edgeFriction: 0.35,
          prevArrow: prevButton.length ? prevButton : undefined,
          nextArrow: nextButton.length ? nextButton : undefined
        });
      }
    }

    function disableSlider() {
      if (slider.hasClass("slick-initialized")) {
        slider.slick("unslick");
      }
    }

    if (isMobile()) enableSlider();
    else disableSlider();

    window.addEventListener("resize", () => {
      if (isMobile()) enableSlider();
      else disableSlider();
    });
  }

  // Bio Popup functionality
  function initBioPopup() {
    const popup = document.getElementById('testimonial-bio-popup');
    const overlay = popup?.querySelector('.testimonial-bio-popup__overlay');
    const closeButton = popup?.querySelector('.testimonial-bio-popup__close');
    const nameElement = popup?.querySelector('.testimonial-bio-popup__name');
    const textElement = popup?.querySelector('.testimonial-bio-popup__text');
    
    if (!popup || !nameElement || !textElement) return;

    function openBioPopup(name, text) {
      if (nameElement) nameElement.textContent = name || '';
      if (textElement) textElement.textContent = text || '';
      popup.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeBioPopup() {
      popup.classList.remove('active');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function(e) {
      const readBioLink = e.target.closest('.mob_read.read_bio');
      if (!readBioLink) return;

      e.preventDefault();
      
      const card = readBioLink.closest('.testimonial-section__card, .testimonial-section__slider-card');
      if (!card) return;

      const nameEl = card.querySelector('.testimonial-section__card-name');
      const popupEl = card.querySelector('.testimonial-section__card-popup-text');
      
      const name = nameEl ? nameEl.textContent.trim() : '';
      const text = popupEl ? popupEl.textContent.trim() : '';

      openBioPopup(name, text);
    });

    if (overlay) {
      overlay.addEventListener('click', closeBioPopup);
    }
    
    if (closeButton) {
      closeButton.addEventListener('click', closeBioPopup);
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.classList.contains('active')) {
        closeBioPopup();
      }
    });
  }

  // Initialize slider
  document.addEventListener("DOMContentLoaded", initTestimonialSlider);

  // Initialize bio popup
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBioPopup);
  } else {
    initBioPopup();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      initTestimonialSlider();
      initBioPopup();
    });
  }
})();
